<div class="save-wrapper" *ngIf=isOpen [@bounceInOnEnter] [@bounceOutOnLeave] (click)="saveFormChanges()">
  <button mat-icon-button class="save-button clickable"  >
    <mat-icon class="save-button-icon">save</mat-icon>
  </button>
</div>